import type {StyleConfig, Values} from '@chakra-ui/system';
import {resolveStyleConfig, useColorMode, useTheme} from '@chakra-ui/system';
import type {ComponentProps, ComponentType} from 'react';
import {forwardRef} from 'react';

import type {StylesProvider} from '../components/Widget/context';

export const withStylesProvider = <T extends object>(
  Component: ComponentType<T & {styleConfig?: StyleConfig} & Partial<Values>>,
  Provider: typeof StylesProvider,
  config: Parameters<typeof resolveStyleConfig>[0],
) => {
  // @ts-expect-error - React 19 type compatibility issue with withStylesProvider component
  const Comp = forwardRef((props: ComponentProps<typeof Component>, ref) => {
    const theme = useTheme();
    const {colorMode} = useColorMode();

    const styleConfig = props.styleConfig || config;
    const style = resolveStyleConfig(styleConfig)({
      theme,
      colorMode,
      orientation: props.orientation,
      variant: props.variant,
      size: props.size,
      colorScheme: props.colorScheme,
    });

    if (!style) {
      console.warn(`No style found for component: ${Component.displayName || Component.name || `Component`}`);
    }

    return (
      <Provider value={style}>
        <Component {...props} ref={ref} />
      </Provider>
    );
  });

  Comp.displayName = `WithStylesProvider(${Component.displayName || Component.name || `Component`})`;
  return Comp;
};
